module.exports = __webpack_public_path__ + "img/shopify-two-en.60e7824f.png";